import BaseLinkify from 'linkify-react';
import React from 'react';

/**
 * @typedef {{
 *   as?: string,
 *   tagName?: string,
 *   options?: import('linkifyjs').Opts,
 *   children?: React.ReactNode} & HTMLElement
 * } LinkifyProps
 */

/** @type {React.FC<LinkifyProps>} */
const Linkify = ({ children, options = {}, ...rest }) => {
  const linkifyOptions = React.useMemo(() => ({ target: { url: '_blank' }, ...options }), []);

  return (
    <BaseLinkify options={linkifyOptions} {...rest}>
      {children}
    </BaseLinkify>
  );
};

export default Linkify;
